import React from "react";
import { AlertCircle, Bell, Calendar, Eye, Target } from "lucide-react";
import { IProjectEvaluationListData } from "../../../project";
import { Col } from "react-bootstrap";
import { getProjectEvaluationLink } from "../../../../../utils/config";
import { CustomDateFormate } from "../../../../../utils/date";
// import EvalStatus from "../../../apps/components/EvalStatus";
import EvaluatorsAvatar from "../EvaluatorsAvatar";
import { Link, useLocation } from "react-router-dom";
interface ProjectCardProps {
    project: IProjectEvaluationListData;
    onReminderClick: (project: IProjectEvaluationListData) => void;
    onReminderLogClick: (project: IProjectEvaluationListData) => void;
}
const ProjectCard = React.memo<ProjectCardProps>(({ project, onReminderClick, onReminderLogClick }) => {
    const location = useLocation();
    const handleReminderClick = () => {
        onReminderClick(project);
    };
    const handleReminderLogClick = () => {
        onReminderLogClick(project);
    };
    return (
        <Col className="col-12">
            <div className="apple-card gestalt-group group border-0 shadow-sm rounded-5 p-3 w-100 mb-4 mb-lg-0">
                <div className="d-flex justify-content-between">
                    <div>
                        <h3 className={`apple-title fw-bold mb-0 fs-5`}><Link to={`/manage-project/${project.project_id}/${location?.search}`} state={{ from: location.state?.from || location.pathname, }} className="text-decoration-none text-dark"> {project.project_name}</Link></h3>
                        <div className="d-flex flex-wrap gap-3 small align-items-center">
                            <div className="text-muted">
                                <Calendar className="me-1" size={14} /> Due: {CustomDateFormate(project.eval_due_date)}
                            </div>
                            {project.priority && <div className="text-danger fw-semibold">
                                <Target className="me-1" size={14} /> {project.priority}
                            </div>}
                            {project.total_reminder_sent > 0 && (
                                <button onClick={handleReminderLogClick} className="btn p-0 border-0 bg-transparent shadow-none text-warning fs-7">
                                    <Bell className="me-1" size={14} /> {project.total_reminder_sent > 1 ? project.total_reminder_sent + ' Reminders Sent' : project.total_reminder_sent + ' Reminder Sent'}
                                </button>
                            )}
                        </div>
                        <div className="mt-3 d-flex gap-3">
                            <Link to={`${getProjectEvaluationLink(project.project_id)}?return_to=${encodeURIComponent(window.location.pathname)}`} className="btn btn-primary btn-sm rounded-4 py-2">
                                <Eye className="me-1" size={14} />View
                            </Link>
                            {project.project_eval_status_key !== 'project_status_2' && project.can_send_reminder === true && (
                                <button onClick={handleReminderClick} className="btn btn-light-primary btn-sm rounded-4 py-2">
                                    <Bell className="me-1" size={14} /> Send Reminder
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="text-end">
                        {/* {project.project_eval_status_key==='project_status_2' && <EvalStatus status={"Gov Sign-Off"} /> } */}
                        <div className="mt-3 d-flex justify-content-end">
                            <EvaluatorsAvatar evaluators={project.evaluators} maxVisible={project.evaluators.length} />
                        </div>
                    </div>
                </div>
            </div>
        </Col>
    )
})
export default ProjectCard;